import axios from 'axios';
import {
  LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAIL,
  REGISTER_REQUEST, REGISTER_SUCCESS, REGISTER_FAIL,
  LOGOUT,
} from '../types/auth';
import { DOMAIN } from '../constants';
import {
  sendLoginNotification,
  sendRegisterNotification,
  sendEmailReminderNotification
} from '../../notifications';

export const login = (email, password) => async (dispatch) => {
  try {
    dispatch({ type: LOGIN_REQUEST });

    const config = { headers: { 'Content-type': 'application/json' } };
    const { data } = await axios.post(`${DOMAIN}/api/v1/accounts/login/`, { email, password }, config);

    dispatch({ type: LOGIN_SUCCESS, payload: data });
    localStorage.setItem('userInfo', JSON.stringify(data));

    // إشعار "welcome back"
    await sendLoginNotification(data);

    // إشعار بعد 3 دقائق لتحفز المستخدم على الشراء
    setTimeout(() => sendEmailReminderNotification(data), 150 * 1000);


  } catch (error) {
    dispatch({
      type: LOGIN_FAIL,
      payload: error.response?.data?.detail || error.message,
    });
  }
};

export const register = (firstName, lastName, email, password, confirmPassword) => async (dispatch) => {
  try {
    dispatch({ type: REGISTER_REQUEST });

    const config = { headers: { 'Content-type': 'application/json' } };
    const { data } = await axios.post(`${DOMAIN}/api/v1/accounts/register/`, { firstName, lastName, email, password, confirmPassword }, config);

    dispatch({ type: REGISTER_SUCCESS, payload: data });
    dispatch({ type: LOGIN_SUCCESS, payload: data });
    localStorage.setItem('userInfo', JSON.stringify(data));

    // إشعار الترحيب
    await sendRegisterNotification(data);

    // إشعار بعد دقيقة لتأكيد البريد الإلكتروني
    setTimeout(() => sendEmailReminderNotification(data), 60 * 1000);


  } catch (error) {
    dispatch({
      type: REGISTER_FAIL,
      payload: error.response?.data?.detail || error.message,
    });
  }
};

export const logout = () => (dispatch) => {
  localStorage.removeItem('userInfo');
  dispatch({ type: LOGOUT });
};
